module.exports = __webpack_public_path__ + "img/note.7db858ae.svg";